import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SessionService } from '../shared/services/session.service';
import { BackendApiService } from '../shared/services/backend-api.service';
import { User } from '../shared/class/user';

@Component({
  selector: 'app-medialist',
  templateUrl: './medialist.component.html',
  styleUrls: ['./medialist.component.css']
})
export class MedialistComponent implements OnInit {
  newuser: User;
  packid: any;
  mediaList: any;

  constructor(
    private snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private sessionService: SessionService,
    private backendApiService: BackendApiService,
    public user: User,
    public dialog: MatDialog,
  ) { }



  getMediaBasedOnPackId(packid){
    this.spinnerService.show();
   // this.mediaList=[];
    const inputData = {       
        "packId":packid,
        "deviceTypes":6
    };
        this.backendApiService.postRawRequest('madiaBasedOnPackId', inputData).subscribe(
          (response: any) => {
            if (response.responseCode === "SC101") {
              this.mediaList= response.mediaList;
              
            } else if (response.responseCode === "FC101") {
              this.snackBar.open("Something went wrong", "close", {
                duration: 2000
              });
            } else {
              this.snackBar.open("Sign up process failed", "", {
                duration: 3000
              });
            }
          },
          error => {
            this.snackBar.open(
              new DOMParser()
                .parseFromString(error.error, "text/html")
                .getElementsByTagName('p')[1].textContent.replace('message',''),
              "",
              {
                duration: 2000,
                verticalPosition: "top",
                horizontalPosition: "center",
                direction: "ltr"
              }
            );
          }
        );
  }

  ngOnInit() {
    this.getMediaBasedOnPackId(this.packid);
  }

}



// WEBPACK FOOTER //
// ./src/app/medialist/medialist.component.ts